import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { includes, isEmpty, last, toLower } from 'lodash';
import langMsg from '@blade-sxp/search-center/lang/index';
import imgFormat from '@blade/common/components/img-checker/img-format.vue';
let default_1 = class default_1 extends Vue {
    size;
    uploadFunc;
    base64Image = null;
    imageValid = false;
    imgData = null;
    loadings = false;
    types = ['bmp', 'jpeg', 'png', 'gif', 'jpg']; // 上传图类型
    maxSize = 8000000;
    get accept() {
        return this.types.map((item) => `image/${item}`).join(', ');
    }
    convertBase64(file) {
        this.$emit('file', file.name);
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = (e) => reject(e);
        }).catch((e) => console.log('error', e));
    }
    async onImgChoosen(data) {
        const { raw, name, size } = data;
        this.imgData = data;
        const base64Image = (await this.convertBase64(raw));
        this.base64Image = base64Image;
        if (await this.isFormatValid(name, size, base64Image)) {
            this.imageValid = true;
            this.onUpload();
        }
        else {
            this.imageValid = false;
        }
        return false;
    }
    async isFormatValid(name, size, base64Image) {
        const suffix = last(name.split('.'));
        const nameValid = includes(this.types, toLower(suffix));
        const maxSize = Number(this.maxSize) || 0;
        const sizeValid = maxSize <= 0 || size <= maxSize;
        return nameValid && sizeValid && this.checkMeasurement(base64Image);
    }
    async checkMeasurement(resource) {
        if (isEmpty(this.size)) {
            return true;
        }
        try {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = (_) => {
                    const { height, width, exactly } = this.size;
                    if (exactly) {
                        resolve(img.height === height && img.width === width);
                    }
                    else {
                        resolve(img.height <= height && img.width <= width);
                    }
                };
                img.src = resource;
                setTimeout(() => {
                    resolve(false);
                }, 5000);
            });
        }
        catch {
            return false;
        }
    }
    remove() {
        this.base64Image = null;
        this.imageValid = false;
    }
    onUpload() {
        this.loadings = true;
        this.uploadFunc(this.base64Image)
            .then(() => {
            // this.$elmessage.success(this.$t('common.success').toString());
            this.$elmessage({
                customClass: 'sub-message',
                message: this.$t('common.success').toString(),
                type: 'success',
            });
        })
            .finally(() => {
            this.loadings = false;
        });
    }
};
__decorate([
    Prop()
], default_1.prototype, "size", void 0);
__decorate([
    Prop()
], default_1.prototype, "uploadFunc", void 0);
default_1 = __decorate([
    Component({
        name: 'ImgChecker',
        components: { imgFormat },
        i18n: {
            messages: {
                en: {
                    click: 'click to upload or drag a image here',
                    formatError: 'Invalid image format /size',
                    upload: 'upload',
                    sizeError: 'File size exceeds ',
                },
                zh: {
                    click: '点击或拖拽上传',
                    formatError: '图片格式/大小无效',
                    upload: '上传',
                    sizeError: '图片大小超过',
                },
            },
            sharedMessages: langMsg,
        },
    })
], default_1);
export default default_1;
